<template>
    <div class="checkout-personal-type">
        <span v-if="result.title">{{ result.title }}</span>
        <ul v-if="result.personTypes">
            <li v-for="personType in result.personTypes">
                <label>
                    <input class="radioBtn"
                           v-on:change="$parent.setAjax"
                           type="radio"
                           name="PERSON_TYPE"
                           :value="personType.ID"
                           :checked="personType.CHECKED"
                    >
                    <span class="text">{{ personType.NAME }}</span>
                </label>
            </li>
        </ul>
    </div>
</template>
<script>
    export default {
        name: "checkout-person-type",
        props: ['result'],
        mounted() {
            if (this.$parent.debug) {
                console.log(this.result);
            }
        }
    }
</script>